/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * OrderOutlineIcon - Auto-generated from icon.js
 */
export const OrderOutlineIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.0508 5.60739C18.1786 5.60739 18.4707 5.62537 18.7262 5.87712C18.8905 6.05694 19 6.29071 19 6.54246V20.0649C19 20.5864 18.5802 21 18.0508 21H5.94915C5.41982 21 5 20.5864 5 20.0649V6.54246C5 6.02098 5.41982 5.60739 5.94915 5.60739H7.59192V5.13986C7.59192 4.83417 7.84746 4.6004 8.1395 4.6004H9.91004C10.1473 3.68332 10.987 3 11.9909 3C12.9948 3 13.8527 3.68332 14.0717 4.6004H15.8422C16.1525 4.6004 16.3898 4.85215 16.3898 5.13986V5.60739H18.0508ZM10.3846 5.67932H8.68709V7.06394H15.3129V5.6973H13.6154C13.3051 5.6973 13.0678 5.44555 13.0678 5.15784V5.06793C13.0495 4.54645 12.575 4.07892 11.9909 4.07892C11.4068 4.07892 10.9322 4.54645 10.9322 5.12188C10.9322 5.42757 10.6767 5.67932 10.3846 5.67932ZM6.07692 6.66833V19.9211H17.9048V6.66833H16.3898V7.17183C16.3898 7.69331 15.9518 8.10689 15.4407 8.10689H8.54107C8.01173 8.10689 7.59192 7.67532 7.59192 7.17183V6.66833H6.07692ZM8.08479 10.7143H15.9153C16.2073 10.7143 16.4446 10.948 16.4629 11.2537C16.4629 11.5594 16.2073 11.7932 15.9153 11.7932H8.08479C7.77449 11.7932 7.5372 11.5415 7.5372 11.2537C7.5372 10.948 7.79274 10.7143 8.08479 10.7143ZM15.9153 13.7892H8.08479C7.79274 13.7892 7.5372 14.023 7.5372 14.3287C7.5372 14.6344 7.77449 14.8681 8.08479 14.8681H15.9153C16.2073 14.8681 16.4629 14.6344 16.4629 14.3287C16.4629 14.023 16.2073 13.7892 15.9153 13.7892ZM8.08479 16.8821H11.2243C11.5163 16.8821 11.7536 17.1159 11.7719 17.4216C11.7719 17.7273 11.5163 17.961 11.2243 17.961H8.08479C7.77449 17.961 7.5372 17.7093 7.5372 17.4216C7.5372 17.1159 7.79274 16.8821 8.08479 16.8821Z"
			fill="current"
		/>
	</svg>
);

export default OrderOutlineIcon;
